import { render, staticRenderFns } from "./Loadingb.vue?vue&type=template&id=3503b4d6&scoped=true&"
import script from "./Loadingb.vue?vue&type=script&lang=js&"
export * from "./Loadingb.vue?vue&type=script&lang=js&"
import style0 from "./Loadingb.vue?vue&type=style&index=0&id=3503b4d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503b4d6",
  null
  
)

export default component.exports